export default __webpack_public_path__ + "static/media/expandMore.0f13a82e.svg";